function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import { endOfMonth, format, getMonth, getYear, isAfter, isBefore, parseISO } from 'date-fns';
var numbersOnlyRegex = new RegExp(/^[0-9]*$/);

/**
 * This is a function that returns a function that can be used to validate values for the
 * DatePicker component.
 */
export function createDatePickerValidator(minDate, maxDate) {
  var granularity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
  var dateFormatDateFns = {
    day: 'yyyy-MM-dd',
    month: 'yyyy-MM',
    year: 'yyyy'
  }[granularity];
  return function (value) {
    if (!value) {
      return true;
    }
    var formatValidationMessage = validateDateFormat(value);
    if (formatValidationMessage !== true) {
      return formatValidationMessage;
    }
    var dateValue = parseISO(value);
    if (granularity === 'day' && isBefore(dateValue, minDate) || granularity === 'month' && (getYear(dateValue) < getYear(minDate) || getYear(dateValue) === getYear(minDate) && getMonth(dateValue) < getMonth(minDate)) || granularity === 'year' && getYear(dateValue) < getYear(minDate)) {
      return "Date cannot be earlier than ".concat(format(minDate, dateFormatDateFns), ".");
    }
    if (granularity === 'day' && isAfter(dateValue, maxDate) || granularity === 'month' && (getYear(dateValue) > getYear(maxDate) || getYear(dateValue) === getYear(maxDate) && getMonth(dateValue) > getMonth(maxDate)) || granularity === 'year' && getYear(dateValue) > getYear(maxDate)) {
      return "Date cannot be later than ".concat(format(maxDate, dateFormatDateFns), ".");
    }
    return true;
  };
}

/**
 * Given a string, this function will validate:
 *
 *    - The string is of the format YYYY-MM-DD
 *    - All characters are numbers
 *    - The month is between [1, 12] inclusive
 *    - The day is > 0
 *    - The day value does not exceed the number of days in the given month
 */
export function validateDateFormat(value) {
  var granularity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
  if (!value || value === 'YYYY-MM-DD') {
    return 'Please select or enter a valid date.';
  }
  var _value$split$0$split = value.split('T')[0].split('-'),
    _value$split$0$split2 = _slicedToArray(_value$split$0$split, 3),
    yearPortion = _value$split$0$split2[0],
    monthPortion = _value$split$0$split2[1],
    dayPortion = _value$split$0$split2[2];
  if (granularity === 'day') {
    if (!yearPortion || !monthPortion || !dayPortion || yearPortion.length === 0 && monthPortion.length === 0 && dayPortion.length === 0) {
      return 'Please select or enter a valid date.';
    }
    if (!numbersOnlyRegex.test(yearPortion) || !numbersOnlyRegex.test(monthPortion) || !numbersOnlyRegex.test(dayPortion) || yearPortion.length !== 4 || monthPortion.length !== 2 || dayPortion.length !== 2 || dayPortion === '00') {
      return 'Please enter a valid date.';
    }
  } else if (granularity === 'month') {
    if (!yearPortion || !monthPortion || yearPortion.length === 0 && monthPortion.length === 0) {
      return 'Please select or enter a valid date.';
    }
    if (!numbersOnlyRegex.test(yearPortion) || !numbersOnlyRegex.test(monthPortion) || yearPortion.length !== 4 || monthPortion.length !== 2) {
      return 'Please enter a valid date.';
    }
  } else if (granularity === 'year') {
    if (!yearPortion || yearPortion.length === 0) {
      return 'Please select or enter a valid date.';
    }
    if (!numbersOnlyRegex.test(yearPortion) || yearPortion.length !== 4) {
      return 'Please enter a valid date.';
    }
  }
  if (granularity !== 'year') {
    var monthValue = Number(monthPortion);
    if (monthValue < 1 || monthValue > 12) {
      return 'Please enter a valid month.';
    }
  }
  if (granularity === 'day') {
    var dateWithYearMonthOnly = new Date(Number(yearPortion), Number(monthPortion) - 1, 1);
    if (Number(dayPortion) > endOfMonth(dateWithYearMonthOnly).getDate()) {
      return 'Please enter a valid date.';
    }
  }
  return true;
}